import { render, staticRenderFns } from "./purposesCloudResume.vue?vue&type=template&id=214d17d0&scoped=true"
import script from "./purposesCloudResume.vue?vue&type=script&lang=js"
export * from "./purposesCloudResume.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "214d17d0",
  null
  
)

export default component.exports